<template>
  <section>
    <div class="step-holder container">
      <div class="columns">
        <div class="column is-9 is-offset-1 stepbar-padding">
          <kinesis-container>
            <div class="step-1-content">
              <h1 class="title">
              hello
              <div class="is-block-mobile is-inline-block-tablet">fellow</div>
              <div class="is-block">
                <span class="typing-word-holder">
                  <transition-group name="fade">
                    <span v-for="(singleWord, index) in presentedWordArray"
                          v-bind:key="index"
                          class="typing-word-holder">
                      {{singleWord}}
                    </span>
                  </transition-group>
                </span>
                </div>
              </h1>
              <div class="columns">
                <div class="column is-2">
                  <kinesis-element :strength="20">
                    <img src="@/assets/line.svg" class="line" />
                  </kinesis-element>
                </div>
                <div class="column">
                  <p>the market changed, liabilites on stock and product market fit are key for a sucessfull fashion brand and that is why we are here. we’ll make sure you no longer have to deal with min orders and keeping stock</p>
                </div>
              </div>
            </div>
          </kinesis-container>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { KinesisContainer, KinesisElement } from 'vue-kinesis'

  export default {
    name: 'Intro',
    components: {
      KinesisContainer,
      KinesisElement
    },
    props: {
      form: Object
    },
    data: function() {
      return {
        presentedWord: '',
        currentWordIndex: 0,
        introWords: ['creator', 'entrepreneur', 'designer', 'brand']
      }
    },
    computed: {
      word() {
        return this.introWords[this.currentWordIndex]
      },
      presentedWordArray() {
        return this.presentedWord.split('')
      }
    },
    mounted() {
      this.emitValidate()

      const speed = 1000 / this.word.length
      this.typeWriter(speed)
    },
    watch: {
      word() {
        setTimeout(() => {
          this.presentedWord = ""

          setTimeout(() => {
            const speed = 700 / this.word.length
            this.typeWriter(speed)
          }, 250);
        }, 3500);
      }
    },
    methods: {
      validate() {
        return true
      },
      emitValidate() {
        this.$emit('validated', this.validate())
      },
      typeWriter(speed) {
        this.presentedWord += this.word.charAt(this.presentedWord.length);
        if (this.presentedWord.length < this.word.length) {
          setTimeout(() => this.typeWriter(speed), speed);
        }

        if (this.presentedWord.length == this.word.length) {
          if (this.currentWordIndex == this.introWords.length-1) {
            this.currentWordIndex = 0
          } else {
            this.currentWordIndex++
          }
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    color: #fff;
    font-weight: 800;
    font-size: 40px;
    line-height: 90.5%;
    max-width: 600px;

    @media screen and (min-width: $tablet) {
      font-size: 100px;
    }
  }

  .line {
    margin-top: 14px;
    width: 46px;

    @media screen and (min-width: $tablet) {
      width: auto;
    }
  }

  p {
    font-weight: 500;
    font-size: 16px;
    line-height: 140%;

    @media screen and (min-width: $tablet) {
      font-size: 32px;
    }
  }

  .typing-word-holder {
    display: inline-block;
  }

  .step-1-content {
    margin-top: 20px;

    @media screen and (min-width: $tablet) {
      margin-top: 0;
    }
  }
</style>
